<mat-toolbar class="map-content-selector" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap=".5em">
    <div class="map-content-selector-text">
        {{text}}
    </div>
    <img *ngIf="showIcon" src="assets/images/warning_noborder.svg" />
</mat-toolbar>

